import api from "@/lib/api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { TENX_BRAND_URL } from "@/lib/branding";

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadDocument(docId, filename) {
  const res = await api.get(`/documents/${docId}/download`, { responseType: "blob" });
  saveBlob(res.data, filename || "document");
}

export async function downloadCsv(path, params, fallbackName) {
  const res = await api.get(path, { params, responseType: "blob" });
  const match = /filename="?([^";]+)"?/.exec(res.headers["content-disposition"] || "");
  saveBlob(res.data, match ? match[1] : fallbackName);
}

export async function exportElementToPdf(el, filename = "update.pdf") {
  if (!el) return;
  const canvas = await html2canvas(el, {
    scale: 2, backgroundColor: "#ffffff", useCORS: true, logging: false,
    // Replace the on-screen footer with real PDF text + URI annotation, not an unclickable bitmap.
    ignoreElements: (node) => node.hasAttribute("data-tenx-brand-footer"),
  });
  const pdf = new jsPDF("p", "pt", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 24;
  const imgWidth = pageWidth - margin * 2;
  const ratio = imgWidth / canvas.width;
  const sliceHeight = Math.floor((pageHeight - margin - 54) / ratio);
  for (let offset = 0; offset < canvas.height; offset += sliceHeight) {
    if (offset) pdf.addPage();
    const slice = document.createElement("canvas");
    slice.width = canvas.width;
    slice.height = Math.min(sliceHeight, canvas.height - offset);
    slice.getContext("2d").drawImage(canvas, 0, offset, canvas.width, slice.height, 0, 0, slice.width, slice.height);
    pdf.addImage(slice.toDataURL("image/png"), "PNG", margin, margin, imgWidth, slice.height * ratio);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    const prefix = "Sent and Powered by ";
    const prefixWidth = pdf.getTextWidth(prefix);
    pdf.setFont("helvetica", "bold");
    const nameWidth = pdf.getTextWidth("TenX");
    const x = (pageWidth - prefixWidth - nameWidth) / 2;
    const y = pageHeight - 24;
    pdf.setTextColor(100, 116, 139);
    pdf.setFont("helvetica", "normal");
    pdf.text(prefix, x, y);
    pdf.setTextColor(23, 48, 43);
    pdf.setFont("helvetica", "bold");
    pdf.text("Ten", x + prefixWidth, y);
    pdf.setTextColor(238,117,1);
    pdf.text("X", x + prefixWidth + pdf.getTextWidth("Ten"), y);
    pdf.link(x + prefixWidth, y - 9, nameWidth, 12, { url: TENX_BRAND_URL });
  }
  pdf.save(filename);
}
